import { createApp } from "vue";

import MobileMenu from "common/js/vue/menu/MobileMenu.vue";
import SidebarMenu from "common/js/vue/menu/SidebarMenu.vue";
import HeaderSearch from "common/js/vue/sitesearch/headersearch.vue";
import SiteSearch from "common/js/vue/sitesearch/sitesearch.vue";
import RssReader from "common/js/vue/rss/rssreader.vue";
import Anmalningsknapp from "./tillfallen/anmalningsknapp.vue";
import ListBlock from "./list/listblock.vue";
import Galleri from "./galleri/galleri.vue";
import DivaListBlock from "common/js/vue/divalista/divalistblock.vue";
import ArtikelListBlock from "common/js/vue/artikellista/listblock.vue";

import lodash from "lodash";
import "url-search-params-delete";

var VuecomponentList = [
  { container: "#mainmenu-mobile-vue", component: MobileMenu },
  { container: "#sidebar-menu-vue", component: SidebarMenu },
  {
    container: "#headersearch-vue",
    component: HeaderSearch,
    props: { useEntypoIcons: true },
  },
  {
    container: "#sitesearch-vue",
    component: SiteSearch,
    props: { useEntypoIcons: true },
  },
  { container: ".rssreader-vue", component: RssReader },
  { container: ".anmalningsknapp-vue", component: Anmalningsknapp },
  { container: ".listblock-vue", component: ListBlock },
  { container: "#galleri-vue", component: Galleri },
  { container: ".divalistblock", component: DivaListBlock },
  { container: ".artikellistblock", component: ArtikelListBlock },
];

var activeApps = [];

function initVueComponent(item) {
  let pagebottomTAG = item.container,
    pagebottomDOMs = document.querySelectorAll(pagebottomTAG);
  pagebottomDOMs.forEach((pagebottomDOM) => {
    if (pagebottomDOM) {
      let rawoptions = pagebottomDOM.getAttribute("data-settings"),
        options = {};
      if (rawoptions) {
        options = JSON.parse(rawoptions);
      }
      if (item.props) {
        var propKeys = Object.keys(item.props);
        propKeys.forEach((key) => {
          if (options[key]) {
            options[key] = item.props[key];
          } else {
            options = {
              ...options,
              [key]: item.props[key],
            };
          }
        });
      }
      const app = createApp(item.component, { ...options });
      if (pagebottomTAG.startsWith(".")) {
        app.mount("#" + pagebottomDOM.id);
      } else {
        app.mount(item.container);
      }
      app.use(lodash);
      activeApps.push(app);
    }
  });
}

export default {
  initVue: function () {
    VuecomponentList.forEach((item) => {
      initVueComponent(item);
    });
  },
  initComponent: function (id) {
    let item = VuecomponentList.find(({ container }) => container === id);
    if (item) {
      initVueComponent(item);
    }
  },
  deleteOldComponent: function (id) {
    if (activeApps.length) {
      activeApps.forEach((app, index) => {
        if (app._container.id == id) {
          app.unmount();
          activeApps.splice(index, 1);
        } else if (app._container.classList.contains(id)) {
          app.unmount();
          activeApps.splice(index, 1);
        }
      });
    }
  },
};
